export default __webpack_public_path__ + "516baf0dfc43d0f68ea1f17d3ee37a38.svg";